<template>
  <div>
    <h2 :class="['headline', 'font-grey', 'font-l-600']" v-html="title" />
    <div :class="['server-side-description']" v-html="description" />
    <vc-timeline @story="onStory($event)" :data="timeline" />
  </div>
</template>
<script>
import methods from '../helpers/methods'

export default {
  name: 'ComingUpPage',
  mixins: [
    methods
  ],
  data () {
    return {
      title: null,
      description: null,
      timeline: []
    }
  },
  mounted () {
    this.$root.$emit(this.$store.state.events.ajaxStart)
    this.$http('/static/data/roadmap.json').then(response => {
      this.timeline = response.data.timeline
      this.getPage()
    })
  },
  methods: {
    onStory (data) {
      console.log(data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/coming-up.vue